import Input2 from "../../../components/input2";
import SubmitBtn2, { SubmitBtn3 } from "../../../components/submit2";
import sty from "./lo.module.scss";
import Header2 from "../../../components/header2";
import Notif from "../../../components/notif";

import PinInput from "react-pin-input";
import { useRef, useState, useEffect } from "react";
import Footer2 from "../../../components/footer2";
import { loaderPostFetch } from "../util";



import {
 Outlet,
 Link,
 useLoaderData,
 useNavigate, 
 useActionData,
 Form,
} from "react-router-dom";

import {wpUser,production} from '../../../../k';

//const production = false;
export async function loginaction({ request, params }) {
 //loader will fetch details
 const formData = await request.formData();
 const updates = Object.fromEntries(formData);

 console.log({updates});

 return formData;
}

export default function Login() {
 let rData = useActionData();
 //const n = useNavigate();

 const [loading, setLoading] = useState(false);
 let [actionData, sactionData] = useState();

 let ele = useRef();

 const [pin, setPin] = useState("");
 
 useEffect(() => {
  if (rData) {
   console.log("this");
   //if (pin.length == 6) {
    setLoading(true);
    loaderPostFetch(`api/users.php?crud=userlogin`, rData)
     .then((c) => {
       console.log({c});
       if (c) {
      sactionData(c);
      setLoading(false);
      }
     })
     .catch((e) => {
      setLoading(false);
     });
   //}
  }
 }, [rData]);

 const [n, sN] = useState({ display: false, type: "success", msg: "" });

 const navigate = useNavigate();

 useEffect(() => {
  /*console.log({ actionData });*/
  if (actionData) {
   let s = actionData;
   if (s?.error) {
    //s?.message

    /*if (typeof s?.ismsg!='undefined') {
         //post to suspension message page

         let s = actionData;
         console.log(s); 
         navigate('../account/info/notice', { state: s?.ismsg });
       }*/

    if (typeof s?.message == "undefined") {
     sN({ display: true, type: "error", msg: `Invalid Credentials` });
     setTimeout(() => {
      sN({ display: false, type: "error", msg: `` });
     }, 5000);
    } else {
     sN({ display: true, type: "error", msg: `${s?.message}` });
     setTimeout(() => {
      sN({ display: false, type: "error", msg: `` });

      if (!s?.verified) {
       window.localStorage.setItem("notverified", true);
       if (s?.email) {
        //window.location.href = `verify/${s?.email}`;
        window.location.href = `${wpUser}/account/emailauth?email=${s?.email}`;
       }
      } else if (s?.verification_status != "Not Verified") {
       window.localStorage.setItem("account_verification", false);

       if (s?.submitted == "No") {
        window.location.href = `${wpUser}/account/kyc/form`;
       } else {
        window.location.href = `${wpUser}/account/kyc/under-review`;
       }
      } else {
      }
     }, 5000);
    }
   } else {
    if (s?.role == "admin") {
     if (typeof s?.message == "undefined") {
     } else {
      sN({ display: true, type: "success", msg: `${s?.message}` });
      setTimeout(() => {
       sN({ display: false, type: "success", msg: `` });
       window.location.href = `${wpUser}/../wp-admin`;
      }, 5000);
     }
    } else {
     /*users*/

     if (typeof s?.ismsg != "undefined") {
      //post to suspension message page

      let s = actionData;
      console.log(s);
      //navigate("../account/info/notice", { state: s?.ismsg });
       window.localStorage.setItem("sbaUid", s?.jwt);

      window.location.href = `info/notice`;
     } else {
      if (s?.verified && !s?.verified) {
       //console.log("usn");
       window.localStorage.setItem("tempbaUid", s?.jwt);

       window.localStorage.setItem("notverified", true);
       if (s?.email) {
        //window.location.href = `verify/${s?.email}`;
        window.location.href = `verify?email=${s?.email}`;
       }
      } else if (
       s?.verification_status == "Not Verified" ||
       s?.verification_status == "Declined"
      ) {
       window.localStorage.setItem("account_verification", false);
       window.localStorage.setItem("tempbaUid", s?.jwt);

       window.location.href = `kyc/form`;
      } else if (s?.verification_status == "Pending Verification") {
       window.localStorage.setItem("account_verification", false);
       window.localStorage.setItem("tempbaUid", s?.jwt);

       window.location.href = `kyc/under-review`;
      } else {
       window.localStorage.setItem("baUid", s?.jwt);
       //window.location.reload();
       if (typeof s?.message == "undefined") {
        sN({ display: true, type: "error", msg: `Welcome Back` });
        setTimeout(() => {
         sN({ display: false, type: "success", msg: `` });
         window.location.href = `${wpUser}/dashboard`;
         //navigate("../dashboard");
        }, 5000);
       } else {
        sN({ display: true, type: "success", msg: `${s?.message}` });
        setTimeout(() => {
         sN({ display: false, type: "success", msg: `` });
         window.location.href = `${wpUser}/dashboard`;

         //navigate("../dashboard");
        }, 5000);
       }
      }
     }
    }
   }
  }
 }, [actionData]);

 const [on, setOn] = useState(false);
 const [tw, setTw] = useState(true);
 const [em, setE] = useState();
 const [userId, setuserId] = useState({});
 const [userT, setuserT] = useState();
 const sav = (e) => {
  //console.log(e.target.value);
  setE(e.target.value);
 };
 const idUser = () => {
  setLoading(true); //set to false after

  let rs = { email: em };
  var form_data = new FormData();

  for (var key in rs) {
   form_data.append(key, rs[key]);
  }
  console.log({ rs });
  loaderPostFetch(`api/users.php?crud=iduser`, form_data)
   .then((c) => {
    console.log({ c });

    if (c) {
      setuserT(c?.role);
    if (c?.error) {
     setLoading(false);
     sN({ display: true, type: "error", msg: `${c?.message}` });
     setTimeout(() => {
      sN({ display: false, type: "success", msg: `` });
     }, 5000);
    } else {
     setuserId(c?.user);
     setOn(true);
     setTw(false);
     setLoading(false);
    }
  }
   })
   .catch((e) => {
    setLoading(false);
   });
 };

 const handlePinComplete = (value) => {
  setPin(value);
 };

 return (
  <div>
   <Notif display={n?.display} type={n?.type} msg={n?.msg} />
   <Header2 href="signup" title="Sign Up" />

   <Form method="post">
    <div className={`${sty.stage1} ${on ? sty.hi : ""}`}>
     <img src={`${wpUser}/lo/logo1.svg`} />

     <div className={sty.li1}>
      <div className={sty.txt}>Login Account</div>

      <img src={`${wpUser}/lo/fing.svg`} />
     </div>

     <div className={sty.igt}>It’s good to have you back!</div>

     <div className={sty.lst}>
      Welcome to your secure online banking portal. Please log in with your
      credentials to access your account, review transactions, manage your
      finances.
     </div>

     <Input2
      onChange={sav}
      oninput={sav}
      placeholder="Enter mail"
      hasIcon="email"
      name="email"
      required={true}
     />

     <div className={sty.remeber}>
      <div className={sty.l}>
       <input type="checkbox" name="remeber" />
       <div className={sty.text}>Remember me</div>
      </div>
      <div className={sty.r}>
       <a href="forgot">Forgot Passcode?</a>
      </div>
     </div>

     <SubmitBtn3
      type="button"
      onClick={idUser}
      label={<>Next</>}
      loading={loading}
     />
    </div>

    <div className={`${sty.stage1} ${tw ? sty.hi : ""}`}>
     <div className={sty.li2}>
      <img
       src={`${
        userId?.picture
         ? `${production ? `${wpUser}/uploads` : ""}/${userId?.picture}`
         : `${wpUser}/lo/defpho.svg`
       }`}
      />
     </div>
     <div className={sty.others}>
      <div className={sty.wb}>Welcome Back</div>
     </div>
     <div className={sty.others}>
      <div className={sty.usrn}>{userId?.fullname}</div>
     </div>
     <div className={sty.others}>
      <div className={sty.du}>
       <img src={`${wpUser}/lo/padlck.svg`} />
       <div className={sty.enter}>Enter Passcode</div>
      </div>
     </div>
     <div className={sty.others}>
     {userT=="admin"?<>

<Input2 placeholder="Enter Password" name="password" type="password" hasIcon="show" toggleIconWith="hide" />

     </>:<>
      <PinInput
       ref={(n) => (ele = n)} /*Set ref */
       onComplete={handlePinComplete}
       length={6}
       focus
       inputMode="number"
       secret
       secretDelay={500}
       inputStyle={{
        border: "2px solid #3498db", // Customize the border color
        borderRadius: "8px", // Adjust border radius
        fontSize: "13px", // Change font size
        fontStyle: "normal",
        fontFamily: "Inter",
        fontWeight: "500",
        width: "30px",
        height: "30px",
        padding: "5px", // Add some padding
        margin: "5px", // Adjust margin
       }}
       inputFocusStyle={{ borderColor: "lightgray" }}
      /><input type="hidden" name="password" value={pin} />
</>}
     </div>
     
     <SubmitBtn3 label={<>Login Account</>} loading={loading} />
    </div>
   </Form>

   <Footer2 />
  </div>
 );
}
